export const Slider = theme => ({
  styleOverrides: {
    valueLabel: {
      borderRadius: 8
    },
    markLabel: {
      fontSize: 12,
      fontWeight: 500,
      color: theme.palette.grey[500]
    }
  }
});